module.exports = __webpack_public_path__ + "img/Color 3.9a90c007.jpg";